<template>
  <div class="w-full overflow-hidden">
    <span
      class="name-line text-flax-smoke-900 font-title! block w-full translate-y-full text-[13vw] leading-[0.85] font-bold tracking-tight uppercase will-change-auto sm:text-[9vw]"
    >
      Ulaş Renas Ordu
    </span>
  </div>
</template>
